import { useTranslation } from "react-i18next";

import { PageWrapper } from "~/components";
import { Heading } from "~/ui";

export const RegularAdmins = () => {
  const { t } = useTranslation();
  return (
    <PageWrapper>
      <Heading>{t("regular_admins.regular_admins")}</Heading>
    </PageWrapper>
  );
};
